import { render, staticRenderFns } from "./FiltroPorProcedimento.vue?vue&type=template&id=deff7288"
import script from "./FiltroPorProcedimento.vue?vue&type=script&lang=ts"
export * from "./FiltroPorProcedimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports